// extracted by mini-css-extract-plugin
export var filterWrapper = "Filter-module--filter-wrapper--18M5K";
export var label = "Filter-module--label--3tHme";
export var checkbox = "Filter-module--checkbox--1bv3i";
export var checkboxSvg = "Filter-module--checkbox-svg--11JKP";
export var colorTag = "Filter-module--color-tag--uOt0_";
export var filterTitle = "Filter-module--filter-title--aIDc9";
export var mobileModal = "Filter-module--mobile-modal--2IOIR";
export var mobileModalCard = "Filter-module--mobile-modal-card--1vBOD";
export var mobileModalBackground = "Filter-module--mobileModalBackground--36p3X";
export var mobileModalFooter = "Filter-module--mobileModalFooter--2jBiC";
export var mobileModalHeader = "Filter-module--mobileModalHeader--1ZUnv";
export var mobileModalBody = "Filter-module--mobileModalBody--1i73T";
export var spinAround = "Filter-module--spinAround--1vviJ";